/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Administratively recorded grade metadata exposed on graded submissions.
 */
export interface AdminOverride {
  comment: string;
}
